export default __webpack_public_path__ + "static/blog-05-1170x600-fab2b3ddda5ff8ae087b888316da25b4.jpg";